module.exports = __webpack_public_path__ + "static/media/21-14.05f8923e.mp3";